import {
  DOCUMENT_TYPES,
  VALID_FILE_OPTIONS,
  VALID_IMAGE_FILE_MIME_TYPES,
  VIDEO_FILE_MIME_TYPES,
} from "@miplatform/constants";
import { getRootUrl } from "../getRootUrl";

export const externalReferenceId = {
  getHomeRefId: ({ homeId }: { homeId: string }) =>
    `home-service/homes/${homeId}`,
  getAccountRefId: ({ accountId }: { accountId: string }) =>
    `account-service/accounts/${accountId}`,
  getProfilePhotoRefId: ({ userId }: { userId: string }) =>
    `subscription-service/profilephoto/${userId}`,
  getPurchaseOrderRefId: ({ purchaseOrderId }: { purchaseOrderId: string }) =>
    `account-service/purchase-orders/${purchaseOrderId}`,
  getStepRefId: ({
    orderId,
    assignmentId,
    attemptId,
    stepId,
  }: {
    orderId: string;
    assignmentId: string;
    attemptId: string;
    stepId: string;
  }) =>
    `task-service/orders/${orderId}/assignments/${assignmentId}/attempts/${attemptId}/steps/${stepId}`,
  getStepResultRefId: ({
    orderId,
    assignmentId,
    attemptId,
    stepId,
    stepResultId,
  }: {
    orderId: string;
    assignmentId: string;
    attemptId: string;
    stepId: string;
    stepResultId: string;
  }) =>
    `task-service/orders/${orderId}/assignments/${assignmentId}/attempts/${attemptId}/steps/${stepId}/step-results/${stepResultId}`,
  getIssueRefId: ({ issueId }: { issueId: string }) =>
    `task-service/issues/${issueId}`,
  getIssueResultRefId: ({
    orderId,
    attemptId,
    issueId,
    issueResultId,
    assignmentId,
  }: {
    orderId: string;
    assignmentId: string;
    attemptId: string;
    issueId: string;
    issueResultId: string;
  }) =>
    `task-service/orders/${orderId}/assignments/${assignmentId}/attempts/${attemptId}/issues/${issueId}/issue-results/${issueResultId}`,
  getAttemptRefId: ({
    orderId,
    assignmentId,
    attemptId,
  }: {
    orderId: string;
    assignmentId: string;
    attemptId: string;
  }) =>
    `task-service/orders/${orderId}/assignments/${assignmentId}/attempts/${attemptId}`,
  getAttemptEmailRefId: ({
    orderId,
    assignmentId,
    attemptId,
    emailId,
  }: {
    orderId: string;
    assignmentId: string;
    attemptId: string;
    emailId: string;
  }) =>
    `task-service/orders/${orderId}/assignments/${assignmentId}/attempts/${attemptId}/emails/${emailId}`,
  getMaterialRefId: ({ materialId }: { materialId: string }) =>
    `home-service/materials/${materialId}`,
  getCommunityRefId: ({ communityId }: { communityId: string }) =>
    `home-service/communities/${communityId}`,
  getAssignmentRefId: ({
    orderId,
    assignmentId,
  }: {
    orderId: string;
    assignmentId: string;
  }) => `task-service/orders/${orderId}/assignments/${assignmentId}`,
  getAppointmentRefId: ({
    orderId,
    assignmentId,
    appointmentId,
  }: {
    orderId: string;
    assignmentId: string;
    appointmentId: string;
  }) =>
    `task-service/orders/${orderId}/assignments/${assignmentId}/appointments/${appointmentId}`,
  getOrderReferenceId: ({ orderId }: { orderId: string }) =>
    `task-service/orders/${orderId}`,
  getOrderEmailRefId: ({
    orderId,
    emailId,
  }: {
    orderId: string;
    emailId: string;
  }) => `task-service/orders/${orderId}/emails/${emailId}`,
};

export const getDocumentTypeByContentType = (contentType: string) => {
  if (VALID_IMAGE_FILE_MIME_TYPES.includes(contentType)) {
    return DOCUMENT_TYPES.IMAGE;
  }
  if (VIDEO_FILE_MIME_TYPES.includes(contentType)) {
    return DOCUMENT_TYPES.UNKNOWN;
  }
  return DOCUMENT_TYPES.UNKNOWN;
};

export const getFileTypeFromMimeType = (mimeType: string) => {
  const fileOption = VALID_FILE_OPTIONS.find(
    (option) => option.value === mimeType
  );
  return fileOption?.label || "UNKNOWN";
};

export const getDocumentUrl = (id: string) => {
  if (!id) return undefined;
  return `${getRootUrl()}/document-service/documents/${id}`;
};
